<template>
	<div class="home" style="background-color: #F6F6F6 !important ">
		<carousel></carousel>

		<!-- <div style="display: flex;width: 75rem;margin: 0 auto;padding: 1.375rem 0;">

			<informationCard :data="noticeData" :lowerText="'Latest Notice'" :title="'最新通知'" style="min-height: 280px;">
			</informationCard>
			<informationCard :data="punishData" :lowerText="'Penalty Notice'" :title="'处罚公告'"
				style="min-height: 280px;margin-left: 130px;"></informationCard>
		</div> -->
		<!-- <div class="serveContainer" v-if="showTrain==true">
			<div style="margin-top: 1.875rem;width: 75rem;margin: 0 auto;padding: 3.450rem  0;">
				<div style="display: flex;align-items: flex-end;margin-bottom: 20px;">
					<div
						style=" font-family: Microsoft YaHei;font-style: normal;font-weight: normal;font-size: 1.5rem;letter-spacing: 1px;margin: 0;color: rgba(0, 0, 0, 0.85);margin-left: 28px;">
						培训报名</div>
					<div
						style="font-family: Arial;font-style: normal;font-weight: normal;font-size: 0.75rem;color: rgba(0, 0, 0, 0.45);">
						<span style="padding: 0 2px;">/</span>Training Registration
					</div>
				</div>

				<trainBox style="margin-top: 2.5rem;" :trainData="trainData"></trainBox>
				<div v-if="showTrain==false" style="height: 300px;"></div>
			</div>

		</div> -->
		<!-- <informationCard :data="newsData" :lowerText="'News Information'" :title="'新闻资讯'"
			style="min-height: 350px;padding-top: 30px"></informationCard>
		<div style="margin: 4.6875rem 0;"></div> -->
		<div class="yyjj" style="width: 1200px;margin: 0 auto;margin-top: 40px;display: flex;justify-content: space-between;">
			<div style="width: 738px;height: 444px;border-radius: 4px;background-color: #FFFFFF;">
				<div
					style="width: 100%;height: 60px;display: flex;justify-content: space-between;align-items: center;padding: 0 16px;border-bottom: 0.5px solid #EBEBEB;">
					<div style="font-size: 24px;">
						医院简介
					</div>
					<div @click="goToDetail" style="font-size: 14px;color: #666666;cursor: pointer;">
						详情 >
					</div>
				</div>
				<div  style="overflow-y: scroll;height:374px;margin-top: 10px;">
					<div style="width: 100%;height: 400px;padding: 0 16px;" v-html="orgd">

					</div>
				</div>

			</div>

			<informationCard :data="noticeData" :lowerText="'Latest Notice'" :title="'通知公告'"
				style="width: 438px; max-height: 444px;background-color: #FFFFFF;">
			</informationCard>
		</div>
		<div class="news" style="width: 1200px;margin: 0 auto;margin-top: 80px;height: 500px; ">
			<div
				style="font-size: 24px; width: 100%;height: 36px;display: flex;justify-content: center;align-items: center;border-bottom: 0.5px solid #DBDBDB;padding-bottom: 13px;">
				<span style="color: #165FDC;font-size: 60px;padding-bottom: 8px;padding-right: 8px;">- </span>大型仪器简介
				<span style="color: #165FDC;font-size: 60px;padding-bottom: 8px;padding-left: 8px;">- </span>
			</div>
			<a-carousel :before-change="nextD" autoplay arrows>
				<div v-for="i in 20">
					<div v-if="flashs" style=" margin-top: 20px; width: 100%;height: 500px;display: flex;flex-wrap: wrap;">
						<div class="instrumentHover" style="margin-left: 8px;margin-right: 8px; justify-content: space-between; padding-top: 10px; display: flex;flex-direction: column;  align-items: center; margin-bottom: 20px; width: 224px;height: 248px;border-radius: 4px;background: #FFFFFF;" v-for="item in selInstrumentData">
							<img  v-if="item.picture=='http://wdrm-admin.zkshare.com'"  style="width: 204px;height: 150px;border-radius: 2px;" src="../assets/images/instrument-default.jpg" >
							<img v-else :src="item.picture" style="width: 204px;height: 150px;border-radius: 2px;">
							<div :title="item.instrumentName" style="text-overflow: ellipsis;max-width: 200px;word-break:keep-all;white-space:nowrap; overflow:hidden;  line-height: 16px !important;flex: 1;color: #333333;font-size: 14px;margin-top: 12px;align-self: flex-start;margin-left: 10px">{{item.instrumentName}}</div>
							<div @click="" style="cursor: pointer; font-size: 12px; color: #666666;margin-bottom: 16px;align-self: flex-end;margin-right: 15px;"  @click="goToIns(item)">查看详情 ></div>
						</div>
						
					</div>
				</div>
				
				
				<!-- <div>
					<h3>3</h3>
				</div>
				<div>
					<h3>4</h3>
				</div> -->
				<div  slot="prevArrow" slot-scope="props" class="custom-slick-arrows" style="left: -90px;zIndex: 1">
					<img @click="prevs"   src="../assets/images/letbut.png">
				</div>
				<div    slot="nextArrow" slot-scope="props" class="custom-slick-arrows" style="right: -90px">
					<img @click="nexts" src="../assets/images/letbut2.png">
				</div>
			</a-carousel>

		</div>
		<div style="width: 100%;height: 100px;">
			
		</div>
	</div>
</template>

<script>
	import {
		Dynamic,
		OfflineTrainings,
		SelUserList,
		Isadministrators,
		SelIsShowTrain,
		RefreshPermissions,
		SelInstrument,
		logoBanner
	} from '@/api/index.js'
	import carousel from '../components/common/carousel.vue'
	import trainBox from '../components/trainBox.vue'
	import informationCard from '../components/informationCard.vue'
	export default {
		name: '/',
		components: {
			carousel,
			informationCard,
			trainBox,
		},
		data() {
			return {
				Dynamic,
				totalCount:0,
				orgd:[],
				flashs:true,
				maxPage:0,
				page:1,
				selInstrumentData:[],
				userList: [],
				newsData: [],
				punishData: [],
				noticeData: [],
				imgs: [],
				showTrain: true,
				trainData: [],
				// noticeData:[{
				// 		title:'2021年元旦期间订购实验动物须知',
				// 		msg:'临近元旦假期，维通利华、华府康、集萃药康等实验动物供应商按照法定假期休假，期间不能运送动物。考虑中心每周三进大批实验动物供应商按照法定假期休假，期间不能运送动物。考虑中心每周三进大批',
				// 		date:'2021-12-24'
				// 	},
				// 	{
				// 		title:'实验动物中心实验人员违规行为处理意见',
				// 		msg:'临近元旦假期，维通利华、华府康、集萃药康等实验动物供应商按照法定假期休假，期间不能运送动物。考虑中心每周三进大批小鼠，经协商，集萃...',
				// 		date:'2021-12-24'
				// 	},
				// 	{
				// 		title:'实验动物中心实验人员违规行为处理意见',
				// 		msg:'临近元旦假期，维通利华、华府康、集萃药康等实验动物供应商按照法定假期休假，期间不能运送动物。考虑中心每周三进大批小鼠，经协商，集萃...',
				// 		date:'2021-12-24'
				// 	}],
				// imgs:{
				// 	title:"最新通知",
				// 	lowerText:'ANNOUNCEMENT',
				// 	img:"http://cdn-ali-img-staticbz.shanhutech.cn/a/201907/31/5d40fc1442745.jpg",
				// 	content:[{
				// 		title:'2021年元旦期间订购实验动物须知',
				// 		msg:'临近元旦假期，维通利华、华府康、集萃药康等实验动物供应商按照法定假期休假，期间不能运送动物。考虑中心每周三进大批实验动物供应商按照法定假期休假，期间不能运送动物。考虑中心每周三进大批',
				// 		date:'2021-12-24'
				// 	},
				// 	{
				// 		title:'实验动物中心实验人员违规行为处理意见',
				// 		msg:'临近元旦假期，维通利华、华府康、集萃药康等实验动物供应商按照法定假期休假，期间不能运送动物。考虑中心每周三进大批小鼠，经协商，集萃...',
				// 		date:'2021-12-24'
				// 	},
				// 	{
				// 		title:'实验动物中心实验人员违规行为处理意见',
				// 		msg:'临近元旦假期，维通利华、华府康、集萃药康等实验动物供应商按照法定假期休假，期间不能运送动物。考虑中心每周三进大批小鼠，经协商，集萃...',
				// 		date:'2021-12-24'
				// 	}]
				// },
				// trainData:[{
				// 	img:'http://cdn-ali-img-staticbz.shanhutech.cn/a/201907/31/5d40fc1442745.jpg',
				// 	title:'云讲堂第一讲：ImageJ实用教程：免疫荧光定量分析（Peter博后分',
				// 	trainDate:'2021/12/24  09:00:00',
				// 	trainLocate:'综合楼11楼1102',
				// 	trainDateEnd:'2021/12/26  09:00:00'
				// },
				// {
				// 	img:'http://cdn-ali-img-staticbz.shanhutech.cn/a/201907/31/5d40fc1442745.jpg',
				// 	title:'云讲堂第二讲：ImageJ实用教程：免疫荧光定量分析（Peter博后分',
				// 	trainDate:'2021/12/24  09:00:00',
				// 	trainLocate:'综合楼11楼1102',
				// 	trainDateEnd:'2021/12/26  09:00:00'
				// },
				// {
				// 	img:'http://cdn-ali-img-staticbz.shanhutech.cn/a/201907/31/5d40fc1442745.jpg',
				// 	title:'云讲堂第三讲：ImageJ实用教程：免疫荧光定量分析（Peter博后分',
				// 	trainDate:'2021/12/24  09:00:00',
				// 	trainLocate:'综合楼11楼1102',
				// 	trainDateEnd:'2021/12/26  09:00:00'
				// },
				// {
				// 	img:'http://cdn-ali-img-staticbz.shanhutech.cn/a/201907/31/5d40fc1442745.jpg',
				// 	title:'云讲堂第四讲：ImageJ实用教程：免疫荧光定量分析（Peter博后分',
				// 	trainDate:'2021/12/24  09:00:00',
				// 	trainLocate:'综合楼11楼1102',
				// 	trainDateEnd:'2021/12/26  09:00:00'
				// },
				// {
				// 	img:'http://cdn-ali-img-staticbz.shanhutech.cn/a/201907/31/5d40fc1442745.jpg',
				// 	title:'云讲堂第五讲：ImageJ实用教程：免疫荧光定量分析（Peter博后分',
				// 	trainDate:'2021/12/24  09:00:00',
				// 	trainLocate:'综合楼11楼1102',
				// 	trainDateEnd:'2021/12/26  09:00:00'
				// }]
			}
		},
		created() {
			
			SelIsShowTrain().then((res) => {
				this.showTrain = res.data.state
			})
			this.getNotice()
			this.getSelInstrument()
			// this.getSelUserList()
			let ifLogin = window.localStorage.getItem('Authorization')
			if (ifLogin) {
				Isadministrators().then((res) => {
					if (res.data.state == true) {
						window.localStorage.setItem('isUser', res.data.state)
						this.$parent.$children[0].reloadToken()
					}

				})
			}


		},
		mounted() {
			// console.log(document.location)
			// debugger
			logoBanner().then((res)=>{
				this.orgd = res.data.data.introduction
				
			})
		},
		methods: {
			goToIns(data){
				console.log(data)
				
				this.$router.push({path:'/largeIns',query:{id:data.instrumentId}})
			},
			nextD(data){
				if(this.off){
					return
				}
				// this.flashs=false
				if(this.page==this.maxPage){
					this.page= 1
				}
				else{
					this.page= this.page+1
				}
				this.getSelInstrument()
			},
			goToDetail(){
				this.$router.push({
					name: 'noticeRichDetail',
					query: {
						core:1
					}
				})
			},
			prevs(){
				this.off = true
				if(this.page==1){
					this.page= this.maxPage
				}
				else{
					this.page= this.page-1
				}
				this.getSelInstrument()
				setTimeout(()=>{
					this.off = false
				},3000)
			},
			nexts(){
				this.off = true
				if(this.page==this.maxPage){
					this.page= 1
				}
				else{
					this.page= this.page+1
				}
				this.getSelInstrument()
				setTimeout(()=>{
					this.off = false
				},3000)
			},
			async getNotice() {
				let noticeData = await Dynamic({
					type: 2,
					page: 1,
					row: 10000,
					name: ""
				})
				let punishData = await Dynamic({
					type: 3,
					page: 1,
					row: 10000,
					name: ""
				})
				let newsData = await Dynamic({
					type: 4,
					page: 1,
					row: 10000,
					name: ""
				})
				let trainData = await OfflineTrainings({
					page: 1,
					row: 10000
				})
				this.trainData = trainData.data.data
				this.noticeData = noticeData.data.data
				this.punishData = punishData.data.data
				this.newsData = newsData.data.data

			},
			async getSelInstrument(){
				let data = {page:this.page,row:10,IsAccessControl:2,isHome:true}
					const res = await SelInstrument(data)
					this.totalCount = res.data.totalCount
					this.maxPage = this.getTotalPageNum(this.totalCount,10)
					// this.flashs=false
					this.selInstrumentData = res.data.data
					// setTimeout(()=>{
						
					// 	this.flashs=true
					// },1)
					
					
					
					console.log(this.maxPage)
				},
				 getTotalPageNum(totalRecord, pageSize) {
				    return  parseInt((totalRecord + pageSize - 1) / pageSize);
				},
			async getSelUserList() {
				let res = await SelUserList()
				this.userList = res.data.data
				this.$store.commit('updateUserList', res.data.data)
				let UserId = window.localStorage.getItem('UserId')
				console.log("ddd")
				if (UserId) {
					let User = {}
					this.userList.map((n) => {
						if (n.userId == UserId) {
							User = n
						}
					})


				}
			},
		},


	}
</script>
<style scoped>
	.serveContainer {
		width: 100%;
		margin: 0 auto;
		background: #F6F8FA;

	}

	.serveBox {
		display: flex;
		justify-content: space-between;
	}

	.serveDiv {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 11.25rem;
		background: #FAFAFA;
		border-radius: 0.25rem;
		flex: 1;
		margin: 0 0.625rem;
	}
</style>

<style scoped>
	/* For demo */
	/* .ant-carousel >>> .slick-slide {
  text-align: center;
  height: 100%;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
} */

	.ant-carousel>>>.slick-slide h3 {
		color: #fff;
	}
</style>
<style scoped>
	/* For demo */
	.news .ant-carousel>>>.slick-slide {
		text-align: center;
		height: 550px;
		/* line-height: 160px; */
		background: transparent;
		overflow: hidden;
	}

	.news .ant-carousel>>>.slick-slide h3 {
		color: #fff;
	}
	
	.news .ant-carousel>>>.instrumentHover:hover{
		box-shadow: 0 0.125rem 0.2625rem 0.2125rem rgba(39, 143, 255,0.5);
		transform: scale(1.01) !important;
		/* background-color: red !important; */
	}
</style>
<style scoped>
	/* For demo */
	.news .ant-carousel>>>.custom-slick-arrow {
		width: 25px;
		height: 25px;
		font-size: 25px;
		color: #fff;
		background-color: rgba(31, 45, 61, 0.11);
		opacity: 0.3;
	}

	.news .ant-carousel>>>.custom-slick-arrow:before {
		display: none;
	}
	
	.news .ant-carousel>>>.custom-slick-arrow:hover {
		opacity: 0.5;
	}

	.news .ant-carousel>>>.slick-slide h3 {
		color: #fff;
	}

	.news .custom-slick-arrows:hover {
		opacity: 0.8;
	}
	
</style>
<style>
	.news .slick-active{
		display: none !important;
	}
	.news .slick-dots{
		display: none !important;
	}
	.news .ant-carousel{
		pointer-events: auto !important;
	}
	.news .ant-carousel .slick-list .slick-slide{
		pointer-events: auto !important;
	}
	
</style>
<style>
	
		/* 设置滚动条的样式 */
			::-webkit-scrollbar {
				width: 8px !important;
				height: 12px;
				background-color: #EEEEEE !important; 
				border-radius: 10px;
				
			}
		
			/* 滚动槽 */
			::-webkit-scrollbar-track {
				-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
				border-radius: 10px;
				
			}
		
			/* 滚动条滑块 */
			::-webkit-scrollbar-thumb {
				
				border-radius: 10px;
				width: 1px;
				border: 1px solid transparent !important;
				background: #B9B9B9 !important;
				-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
			}
		
			::-webkit-scrollbar-thumb:window-inactive {
				background: transparent !important;
				
			}
		

</style>